import { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
} from '@mui/material';
import { Close, Warning } from '@mui/icons-material';
import newLogoDark from '../../assets/new-logo-dark.png';
import styles from './RedirectModal.module.scss';

const STORAGE_KEY = 'redirect_modal_dismissed';

const RedirectModal = () => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const isDismissed = sessionStorage.getItem(STORAGE_KEY) === 'true';
        if (!isDismissed) {
            setOpen(true);
        }
    }, []);

    const handleClose = () => {
        sessionStorage.setItem(STORAGE_KEY, 'true');
        setOpen(false);
    };

    return (
        <>
            {open && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        zIndex: 1300,
                    }}
                />
            )}
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                sx={{
                    '& .MuiDialog-paper': { maxWidth: '420px' },
                }}
                hideBackdrop
            >
                <DialogTitle className={styles.title}>
                    <Warning sx={{ fontSize: '20px' }} />
                    Outdated Version Warning
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: 'inherit',
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent
                    sx={{
                        textAlign: 'center',
                        fontSize: '16px',
                        padding: '20px 40px',
                        paddingTop: '20px !important',
                    }}
                    className={styles.content}
                >
                    <div className={styles.logoRow}>
                        ✨
                        <img
                            src={newLogoDark}
                            alt="ThoughtRiver Logo"
                            className={styles.logo}
                        />
                        ✨
                    </div>
                    <div>
                        <strong>We've updated!</strong>
                        <br />
                        Click below for the latest version.
                    </div>
                </DialogContent>
                <DialogActions className={styles.actions}>
                    <Button onClick={handleClose} color="primary">
                        Stay outdated
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            window.location.href = window.__APP_CONFIG__.mfeUrl;
                        }}
                    >
                        Take Me There
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default RedirectModal;
